// import ReactGA from 'react-ga';
//
// export const initializeAnalytics = (trackingId) => {
//     ReactGA.initialize(trackingId);
// };


// export const sendEvent = (category, action, label) => {
    // window.dataLayer = window.dataLayer || [];
    // function gtag(){dataLayer.push(arguments);}
    // gtag('js', new Date());
    // gtag('config', 'G-L3H4XW2M9H');

    // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    //         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    // })(window,document,'script','dataLayer','GTM-K38SKWW4');

    // gtag('event', 'click', {
    //     'event_category': category,
    //     'event_label': label
    // });
    // ReactGA.event({
    //     category: category,
    //     action: action,
    //     label: label
    // });


// };

import ReactGA from 'react-ga4';

ReactGA.initialize('G-L3H4XW2M9H');

export const sendEvent = (eventName, params) => {
    ReactGA.event(eventName, params);
};
